import { format } from 'date-fns'

export default {
    dashboardItems: [],
    paperNeeded: [],
    ordersProcesses: [],
    processedOrders: [],
    newOrders: [],
    numberOfOrdersPerImposition: [],
    paperNeededLoading: false,
    ordersProcessesLoading: false,
    processedOrdersLoading: false,
    newOrdersLoading: false,
    userTasks: [],
    userTasksLoading: false,
    machinesDashboard: null,
    hasMachinesDashboard: false,
    ordersProductsPerDayNotSent: [],
    dashboardSections: [],
    pagination: {},
    paginationSettings: {},
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
}

function setInitialFilters() {
    return {
        checkDate__gte: format(new Date(), 'YYYY-MM-DD'),
        checkDate__lte: format(new Date(), 'YYYY-MM-DD'),
        productionDepartment_id: null
    }
}
